<app-guest-auth-main-layout>
  <ng-template>
    <form class="mt-2" [formGroup]="form" (ngSubmit)="submitForm(form.value)">
      <mat-form-field appearance="outline">
        <mat-label>{{"Nywila Mpya" |concat|translate }}</mat-label>
        <input matInput type="text" formControlName="newPassword" required>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{"Thibitisha Nywila" |concat|translate }}</mat-label>
        <input matInput type="text" formControlName="confirmPassword" required>
      </mat-form-field>

      <div class="">
        <button class="w-full !p-3 !bg-primary-500 !text-white" mat-raised-button> {{"Badili Nywila" |concat|translate }}</button>
      </div>
    </form>
  </ng-template>
</app-guest-auth-main-layout>
